// extracted by mini-css-extract-plugin
export var cardTitle = "_jp-1";
export var commentBubble = "_jp-e";
export var commentForm = "_jp-a";
export var commentInput = "_jp-b";
export var commentLabel = "_jp-d";
export var commentPrompt = "_jp-9";
export var csatCard = "_jp-0";
export var feedbackSection = "_jp-7";
export var starDisabled = "_jp-6";
export var starEmpty = "_jp-5";
export var starFilled = "_jp-4";
export var starWrapper = "_jp-3";
export var starsContainer = "_jp-2";
export var submittedComment = "_jp-c";
export var thankYouText = "_jp-8";